"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeRewardsSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var reward_form_modal_1 = require("./reward_form_modal");
var label_1 = require("../../../../../controls/label");
var letsachieve_1 = require("../../../../../api/letsachieve");
var constants_1 = require("../../items/constants");
function ItemName(_a) {
    var item_id = _a.item_id;
    var _b = (0, letsachieve_1.useGetItemQuery)(item_id, { skip: !item_id }), item = _b.data, isError = _b.isError;
    if (!item)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isError || !item_id ? "Unknown badge" : "Loading badge" });
    // a new tab, so following the link never discards an unsaved challenge
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: (0, constants_1.itemPagePath)(item.type, item.id), target: "_blank", rel: "noreferrer", className: "text-accent hover:underline", children: item.name }));
}
var getRewardIcon = function (type) {
    switch (type) {
        case "xp":
            return "solar:star-bold";
        case "level":
            return "solar:cup-star-bold";
        case "badge":
            return "solar:medal-ribbons-star-bold";
        case "cashback":
            return "solar:wallet-money-bold";
        default:
            return "solar:gift-bold";
    }
};
var getRewardLabel = function (reward) {
    switch (reward.type) {
        case "xp":
            return "".concat(reward.value, " XP");
        case "level":
            return "Level ".concat(reward.value);
        case "cashback":
            return reward.currency_type === "percentage"
                ? "".concat(reward.value, "% Cashback (").concat(reward.currency, ")")
                : "".concat(reward.value, " ").concat(reward.currency, " Cashback");
        default:
            return String(reward.value);
    }
};
var getRewardTypeLabel = function (type) {
    switch (type) {
        case "xp":
            return "XP Points";
        case "level":
            return "Level";
        case "badge":
            return "Badge";
        case "cashback":
            return "Cashback";
        default:
            return type;
    }
};
var ChallengeRewardsSection = function (_a) {
    var rewards = _a.rewards, onChange = _a.onChange, _b = _a.isReadOnly, isReadOnly = _b === void 0 ? false : _b;
    var _c = (0, react_3.useState)(false), isModalOpen = _c[0], setIsModalOpen = _c[1];
    var _d = (0, react_3.useState)(null), editingReward = _d[0], setEditingReward = _d[1];
    var handleAddReward = function () {
        setEditingReward(null);
        setIsModalOpen(true);
    };
    var handleEditReward = function (reward) {
        setEditingReward(reward);
        setIsModalOpen(true);
    };
    var handleDeleteReward = function (rewardId) {
        var updatedRewards = rewards.filter(function (reward) { return reward._id !== rewardId; });
        onChange(updatedRewards);
    };
    var handleSaveReward = function (reward) {
        var updatedRewards;
        if (editingReward === null || editingReward === void 0 ? void 0 : editingReward._id) {
            updatedRewards = rewards.map(function (existing) { return (existing._id === editingReward._id ? __assign(__assign({}, reward), { _id: existing._id }) : existing); });
        }
        else {
            var newReward = __assign(__assign({}, reward), { _id: "temp_".concat(Date.now()) });
            updatedRewards = __spreadArray(__spreadArray([], rewards, true), [newReward], false);
        }
        onChange(updatedRewards);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row items-center justify-between", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: "Challenge Rewards", textColor: "text-primary", bold: true }), !isReadOnly ? ((0, jsx_runtime_1.jsxs)(react_1.Button, { size: "sm", variant: "tertiary", onPress: handleAddReward, children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:plus", width: 20 }), "Add Reward"] })) : null] }), rewards && rewards.length > 0 ? ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col divide-y divide-border rounded-xl border border-border", children: rewards.map(function (reward) { return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row items-center gap-2 px-2 py-1.5", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary/10", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: getRewardIcon(reward.type), width: 18, className: "text-primary" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex min-w-0 flex-1 flex-col leading-tight", children: [(0, jsx_runtime_1.jsx)("span", { className: "truncate text-sm font-medium", children: reward.type === "badge" ? (0, jsx_runtime_1.jsx)(ItemName, { item_id: String(reward.value) }) : getRewardLabel(reward) }), (0, jsx_runtime_1.jsx)("span", { className: "truncate text-[11px] text-muted", children: getRewardTypeLabel(reward.type) })] }), !isReadOnly ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "ghost", isIconOnly: true, "aria-label": "Edit reward", onPress: function () { return handleEditReward(reward); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:pen-linear", width: 16 }) }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "ghost", isIconOnly: true, "aria-label": "Delete reward", className: "text-danger", onPress: function () { return handleDeleteReward(reward._id); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:trash-bin-trash-linear", width: 16 }) })] })) : null] }, reward._id)); }) })) : ((0, jsx_runtime_1.jsx)(react_1.Card, { className: "gap-0 border border-dashed border-border p-0", children: (0, jsx_runtime_1.jsx)(react_1.Card.Content, { className: "p-4", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center justify-center gap-2 text-center", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:gift-linear", width: 32, className: "text-muted" }), (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-muted", children: "No rewards added yet" }), !isReadOnly ? (0, jsx_runtime_1.jsx)("span", { className: "text-xs text-muted", children: "Click \"Add Reward\" to create your first reward" }) : null] }) }) })), (0, jsx_runtime_1.jsx)(reward_form_modal_1.RewardFormModal, { isOpen: isModalOpen && !isReadOnly, onClose: function () {
                    setIsModalOpen(false);
                    setEditingReward(null);
                }, onSave: handleSaveReward, editReward: editingReward })] }));
};
exports.ChallengeRewardsSection = ChallengeRewardsSection;
